import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { CHECKOUT_URL, HERO_IMAGE, HERO_IMAGE_ALT } from '../data/product';
const included = ['6 volumes · 300 landscape pages', '96 ready-to-run practices (2-page spreads)', '18 worksheets + 6 pocket field cards', '5 bonuses, incl. the 12-Week Season Map', 'U8–U10 & U12–U14 · field boys & girls notes', 'Lifetime access to your files'];
export function Pricing() {
  return <section id="pricing" aria-labelledby="pricing-heading" className="w-full bg-chalk text-navy" data-id="element-191" data-mp="1rthydsbvcwck">
      <div className="max-w-2xl mx-auto px-5 py-16 sm:py-20" data-id="element-192" data-mp="25t96xdjm9kj6">
        <div className="text-center" data-id="element-193" data-mp="20t4qtommerth">
          <p className="text-[11px] font-semibold uppercase tracking-[1.6px] text-turf" data-id="element-194" data-mp="20s3bv92hhl6h">Complete package</p>
          <h2 id="pricing-heading" className="mt-3 font-display font-bold uppercase text-navy text-3xl sm:text-5xl" data-id="element-195" data-mp="3h638ob618upi">
            Your whole season, planned
          </h2>
        </div>

        <div className="mt-8 overflow-hidden rounded-3xl border border-chalk-dark bg-white shadow-soft" data-id="element-196" data-mp="3vyf4ql3c4nyo">
          <div className="bg-navy px-5 py-5 text-center" data-id="element-197" data-mp="4s4c9dce4viy">
            <h3 className="font-display text-xl font-bold uppercase tracking-wide text-white sm:text-2xl" data-id="element-198" data-mp="9s8qsxtqng6j">
              No-Lines Lacrosse — Complete Package
            </h3>
            <p className="mt-1 text-[13px] font-semibold uppercase tracking-widest text-gold" data-id="element-199" data-mp="ep8y1c2bqoz8">
              6 Volumes + 5 Bonuses
            </p>
          </div>

          <div className="p-5 sm:p-7" data-id="element-200" data-mp="3i93kbmonbo7y">
            <img src={HERO_IMAGE} alt={HERO_IMAGE_ALT} width={2048} height={1365} loading="lazy" className="aspect-[3/2] w-full rounded-2xl object-cover" data-id="element-201" data-mp="3i5xshzomu88j" />

            <ul className="mt-6 grid gap-2.5 sm:grid-cols-2" data-id="element-202" data-mp="2uheo3v8peflq">
              {included.map(item => <li key={item} className="flex items-start gap-2 text-sm text-navy" data-id="element-203" data-mp="2zgiygp7d6jdn">
                  <span className="mt-0.5 flex h-[18px] w-[18px] flex-none items-center justify-center rounded-full bg-turf" data-id="element-204" data-mp="2rg333zwctslv">
                    <CheckIcon className="h-3 w-3 text-white" aria-hidden="true" data-id="element-205" data-mp="2mh8nf6took5z" />
                  </span>
                  {item}
                </li>)}
            </ul>

            <div className="mt-7 border-t border-chalk-dark pt-6 text-center" data-id="element-206" data-mp="2w8mkz922r9wh">
              <p className="text-[13px] text-navy/60" data-id="element-207" data-mp="28h7auu423oao">
                Total value <span className="line-through" data-id="element-208" data-mp="28jtrdj8xde51">$97 USD</span>
              </p>
              <div className="mt-1 flex items-start justify-center gap-1 text-navy" data-id="element-209" data-mp="23kqqmazz9u2v">
                <span className="mt-2.5 font-display text-3xl font-bold" data-id="element-210" data-mp="2ihrf85mvh8x4">$</span>
                <span className="font-display text-[56px] font-bold leading-[0.9] sm:text-7xl" data-id="element-211" data-mp="2dg21ujc6gj5v">27</span>
                <span className="mt-3 text-[13px] font-semibold text-navy/50" data-id="element-212" data-mp="3tu0mbrymouvg">USD</span>
              </div>

              <div className="mt-3 flex flex-wrap justify-center gap-2" data-id="element-213" data-mp="3ovqrjigtfwad">
                <span className="rounded bg-gold px-2.5 py-1 text-[10px] font-semibold uppercase tracking-widest text-gold-ink" data-id="element-214" data-mp="a42rp0cwqnv">
                  Save $70
                </span>
                <span className="rounded border border-chalk-dark px-2.5 py-1 text-[10px] font-semibold uppercase tracking-widest text-navy/60" data-id="element-215" data-mp="3nfcyqnorql5b">
                  One-time payment
                </span>
                <span className="rounded border border-chalk-dark px-2.5 py-1 text-[10px] font-semibold uppercase tracking-widest text-navy/60" data-id="element-216" data-mp="j0d4yyw58ifk">
                  No app, no subscription
                </span>
              </div>

              <CtaButton href={CHECKOUT_URL} className="mt-5" data-id="element-217" data-mp="a7s08mpckc9q">
                Get No-Lines Lacrosse — only $27
              </CtaButton>

              <p className="mt-3 text-xs text-navy/55" data-id="element-218" data-mp="e7sea68jalg9">Backed by the 7-day money-back guarantee</p>

              <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-medium text-navy/70" data-id="element-219" data-mp="11xwhwdlq2l79">
                <li className="flex items-center gap-1.5" data-id="element-220" data-mp="3f7ih1xu7jeja">
                  <LockIcon className="h-4 w-4 text-turf" aria-hidden="true" data-id="element-221" data-mp="3f8tny6iy92em" />
                  Secure checkout
                </li>
                <li className="flex items-center gap-1.5" data-id="element-222" data-mp="359cldxyzv4mv">
                  <ZapIcon className="h-4 w-4 text-turf" aria-hidden="true" data-id="element-223" data-mp="359un3a4feb26" />
                  Access in 5 minutes
                </li>
                <li className="flex items-center gap-1.5" data-id="element-224" data-mp="1sm8r08wptc7">
                  <ShieldCheckIcon className="h-4 w-4 text-turf" aria-hidden="true" data-id="element-225" data-mp="1s44phg06atq" />
                  7-day guarantee
                </li>
              </ul>
            </div>
          </div>
        </div>

        <p className="mt-4 text-center text-xs text-navy/55" data-id="element-226" data-mp="3o6nf731ux5ux">
          Price in USD. You&apos;ll be charged the equivalent in your local currency.
        </p>
      </div>
    </section>;
}